import React, { Component } from "react";
import "./paymentInfoModal.css";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { AiOutlineClose } from "react-icons/ai";
import Modal from "react-bootstrap/Modal";

//Notice
class PaymentInfoModal extends Component {
  state = { show: true };

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props != prevProps) {
    }
  }

  goToURL = (url) => {
    this.handleClose();
    this.props.history.push({ pathname: url, megastate: { from: true } });
  };

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  getTitle = (type) => {
    switch (type) {
      default:
        return this.props.localizedText["important-notice"];
    }
  };

  getMessage = (type) => {};

  render() {
    return (
      <React.Fragment>
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          className="primary-modal"
          centered
        >
          <Modal.Header>
            <Modal.Title>
              {this.getTitle(process.env.REACT_APP_REGION)}
            </Modal.Title>
            <AiOutlineClose
              className="close-button"
              onClick={this.handleClose}
            />
          </Modal.Header>
          <Modal.Body style={{ "white-space": "pre-wrap" }}>
            {this.props.localizedText["payouts-temporary-hold-notice"]}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="outside-secondary-button"
              onClick={this.handleClose}
            >
              {this.props.localizedText["close"]}
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default withRouter(PaymentInfoModal);
